module.exports = __webpack_public_path__ + "img/add.b1807d2a.png";